import { Fragment } from "react";

import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import MyTextField from "components/Inputs/MyTextField";

const disabledFieldSx = {
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: "action.hover",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "text.secondary",
  },
};

const CompanyPaymentForm = (props) => {
  const { values } = props;
  const { t } = useTranslation();

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Box sx={{ mb: "32px" }}>
            <Grid container direction="row" spacing={1}>
              <Grid size={{ xs: 12 }}>
                <MyTextField
                  disabled
                  autoFocus
                  customLabel={t("Yrityksen nimi")}
                  id="business_profile_name"
                  name="business_profile_name"
                  value={values?.business_profile?.name || ""}
                  sx={disabledFieldSx}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <MyTextField
                  disabled
                  customLabel={t("Osoite")}
                  id="street_address"
                  name="street_address"
                  value={values?.business_profile?.support_address?.line1 || ""}
                  sx={disabledFieldSx}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <MyTextField
                  disabled
                  customLabel={t("Paikkakunta")}
                  id="company-city"
                  name="city"
                  value={values?.business_profile?.support_address?.city || ""}
                  sx={disabledFieldSx}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <MyTextField
                  disabled
                  customLabel={t("Puhelin")}
                  id="business_profile_support_phone"
                  name="business_profile_support_phone"
                  value={values?.business_profile?.support_phone || ""}
                  sx={disabledFieldSx}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <MyTextField
                  disabled
                  customLabel={t("Sähköposti")}
                  id="email"
                  name="email"
                  value={values?.email || ""}
                  sx={disabledFieldSx}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mb: "16px" }}>
            <Grid container direction="row" spacing={1}>
              {values?.external_accounts?.data &&
              values?.external_accounts?.data.length > 0 ? (
                <Fragment>
                  {values?.external_accounts?.data.map((account, index) => (
                    <Fragment key={account.id ?? index}>
                      <Grid size={{ xs: 12 }}>
                        <MyTextField
                          disabled
                          customLabel={t("Tili")}
                          id={`account-${index}`}
                          name="account"
                          value={account.account || ""}
                          sx={disabledFieldSx}
                        />
                      </Grid>

                      <Grid size={{ xs: 12 }}>
                        <MyTextField
                          disabled
                          customLabel={t("Pankki")}
                          id={`bank_name-${index}`}
                          name="bank_name"
                          value={account.bank_name || ""}
                          sx={disabledFieldSx}
                        />
                      </Grid>

                      <Grid size={{ xs: 12 }}>
                        <MyTextField
                          disabled
                          customLabel={t("Maa")}
                          id={`country-${index}`}
                          name="country"
                          value={account.country || ""}
                          sx={disabledFieldSx}
                        />
                      </Grid>

                      <Grid size={{ xs: 12 }}>
                        <MyTextField
                          disabled
                          customLabel={t("Valuutta")}
                          id={`currency-${index}`}
                          name="currency"
                          value={account.currency || ""}
                          sx={disabledFieldSx}
                        />
                      </Grid>
                    </Fragment>
                  ))}
                </Fragment>
              ) : null}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default CompanyPaymentForm;
